module.exports = __webpack_public_path__ + "img/logo_dyw.141a109e.png";